<template>
  <div>
    <template v-if="!getTextModel">
      <el-switch
        v-model="form[item.bind]"
        v-bind="item"
        @change="
          (val) => {
            item.change && item.change(val, item);
          }
        "
      ></el-switch>
    </template>
    <div v-else>
      {{ form[item.bind] }}
    </div>
  </div>
</template>

<script>
export default {
  name: "FormItemSwitch",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    formComConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || '' === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// packages/SrAdd/components/form-item-switch.vue